import { Component, Input } from '@angular/core';
import { IconName, IconShape, ICON_REGISTRY } from './icon.registry';

@Component({
  selector: 'app-icon',
  template: `
    <svg
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <ng-container *ngFor="let shape of shapes">
        <path *ngIf="shape.t === 'path'" [attr.d]="shape.d"></path>
        <circle *ngIf="shape.t === 'circle'" [attr.cx]="shape.cx" [attr.cy]="shape.cy" [attr.r]="shape.r"></circle>
        <rect *ngIf="shape.t === 'rect'" [attr.x]="shape.x" [attr.y]="shape.y" [attr.width]="shape.w" [attr.height]="shape.h" [attr.rx]="shape.rx"></rect>
      </ng-container>
    </svg>
  `,
  styles: [`:host { display: inline-flex; align-items: center; justify-content: center; }`]
})
export class AppIconComponent {
  @Input() name: IconName | string = 'home';
  @Input() size = 17;
  @Input() strokeWidth = 1.8;

  get shapes(): IconShape[] {
    return ICON_REGISTRY[this.name as IconName] || [];
  }
}
